import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../global-config'
import { TENANT } from '../../tenant'

import { ContactPageChatBotLabel } from './ContactPageDirectContactLabels/ContactPageChatBotLabel'
import { ContactPageFormLabel } from './ContactPageDirectContactLabels/ContactPageFormLabel'
import { ContactPagePhoneLabel } from './ContactPageDirectContactLabels/ContactPagePhoneLabel'
import { ContactPagePostCardLabel } from './ContactPageDirectContactLabels/ContactPagePostCardLabel'

export const ContactPageDirectContactLabelsSection: FC<{
  onSuccess: () => void
}> = ({ onSuccess }) => {
  const config = useGlobalConfigContext()

  const hasPharmaLabelsColumn = config.tenant === TENANT.COM

  const hasChatbotLabel = [
    TENANT.AT,
    TENANT.BE,
    TENANT.COM,
    TENANT.IT,
  ].includes(config.tenant)

  return (
    <div className="flex-1">
      <div
        className={clsx(
          'flex flex-col justify-center',
          hasPharmaLabelsColumn ? 'items-start' : 'items-center',
        )}
      >
        {hasPharmaLabelsColumn ? (
          <h2 className="mb-4 text-l font-medium">
            <FormattedMessage id="contact.directContactSection.title" />
          </h2>
        ) : null}
        <div
          className={clsx(
            'flex w-full flex-col items-start gap-6 rounded-2xl border border-dark-primary-min p-6',
            !hasPharmaLabelsColumn && 'tablet:w-1/2',
          )}
        >
          {hasChatbotLabel ? <ContactPageChatBotLabel /> : null}
          <ContactPagePhoneLabel onSuccess={onSuccess} />
          <ContactPageFormLabel onSuccess={onSuccess} />
          {config.tenant === TENANT.COM && <ContactPagePostCardLabel />}
        </div>
      </div>
    </div>
  )
}
